module.exports = __webpack_public_path__ + "img/canbadge-round-44mm-asa_line.7692ef50.png";